export const defaultMagneticMediaFormats = () => {
    return {
        loading: false,
        form: {
            code: "",
            description: ""
        },
        table: {
            loading: false,
            data: [],
            columns: [
                { name: "Codigo", field: "code", width: 150 },
                { name: "Descripción", field: "description", width: 150 },
                {
                    name: "Acciones",
                    field: "actions",
                    width: 150
                }
            ]
        }
    };
};

export const defaultMagneticMediaConcepts = () => {
    return {
        loading: false,
        form: {
            code: "",
            description: ""
        },
        table: {
            loading: false,
            data: [],
            columns: [
                { name: "Codigo", field: "code", width: 150 },
                { name: "Descripción", field: "description", width: 150 },
                {
                    name: "Acciones",
                    field: "actions",
                    width: 150
                }
            ]
        }
    };
};

export const defaultMagneticMediaColumns = () => {
    return {
        loading: false,
        vrSelectionOptions: [],
        regimeOptions: [],
        contacts: [],
        form: {
            number: "",
            title: "",
            description: "",
            vr_selection: "",
            limit_value: "",
            regime_id: "",
            contact_id: "",
            magnetic_media_concept_id: ""
        },
        table: {
            loading: false,
            data: [],
            columns: [
                { name: "Columna", field: "number", width: 150 },
                // { name: "Titulo Excel", field: "title", width: 150 },
                { name: "Descripción", field: "description", width: 150 },
                { name: "Selección Vr", field: "vr_selection", width: 150 },
                { name: "Regimen", field: "regime_id", width: 150 },
                { name: "Vr-Tope", field: "limit_value", width: 150 },
                { name: "Tercero bajo Tope", field: "contact_id", width: 150 },
                {
                    name: "Acciones",
                    field: "actions",
                    width: 150
                }
            ]
        }
    };
};

export const defaultMagneticMediaRangeAccounts = () => {
    return {
        loading: false,
        form: {
            account_from_id: "",
            account_to_id: ""
        },
        table: {
            loading: false,
            data: [],
            columns: [
                { name: "Cuenta Desde", field: "account_from_id", width: 150 },
                { name: "Cuenta Hasta", field: "account_to_id", width: 150 },
                {
                    name: "Acciones",
                    field: "actions",
                    width: 150
                }
            ]
        }
    };
};

export const defaultMagneticMediaReport = () => {
    return {
        loading: false,
        data: [],
        columns: [
            {
                headerName: "Concepto",
                field: "concept",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                editable: false
            },
            {
                headerName: "Tipo Ident",
                field: "type_ident",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (!params.value) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    if (params.value == 31 && params.data.ident.length !== 9) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "Ident",
                field: "ident",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (!params.value) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    if (
                        params.data.type_ident == 31 &&
                        !["8", "9"].includes(params.value.toString().charAt(0))
                    ) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "DV",
                field: "dv",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true
            },
            {
                headerName: "Apellido-1",
                field: "surname1",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (
                        ["13", "41", "22", "42"].includes(
                            params.data.type_ident
                        ) &&
                        !params.value
                    ) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "Apellido-2",
                field: "surname2",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true
            },
            {
                headerName: "Nombre-1",
                field: "name1",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (
                        ["13", "41", "22", "42"].includes(
                            params.data.type_ident
                        ) &&
                        !params.value.replace(" ", "")
                    ) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "Nombre-2",
                field: "name2",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true
            },
            {
                headerName: "Razon Social",
                field: "companyName",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (
                        params.data.type_ident == 31 &&
                        !params.value.replace(" ", "")
                    ) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "Direccion",
                field: "address",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (!params.value) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    if (params.value.replace(" ", "").length < 5) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    if (!/^[A-Za-z0-9 . -]*$/.test(params.value)) {
                        return { backgroundColor: "#ffccdd" };
                    }

                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "Teléfono",
                field: "main_telephone",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                hide: true
            },
            {
                headerName: "Email",
                field: "email",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                hide: true
            },
            {
                headerName: "Dep",
                field: "dep",
                cellClass: "dep",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (!params.value) {
                        return { backgroundColor: "#ffccdd" };
                    }
                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "Mun",
                field: "mun",
                cellClass: "mun",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true,
                cellStyle: params => {
                    if (!params.value) {
                        return { backgroundColor: "#ffccdd" };
                    }
                    return { backgroundColor: "" };
                }
            },
            {
                headerName: "Pais",
                field: "city",
                cellClass: "city",
                width: 150,
                resizable: true,
                sortable: true,
                filter: true
            },
            {
                width: 180,
                headerName: "Acciones",
                field: "actions",
                editable: false,
                filter: false,
                colId: "actions"
            }
        ],
        excelStyles: [
            {
                id: "dep",
                dataType: "String"
            },
            {
                id: "mun",
                dataType: "String"
            },
            {
                id: "city",
                dataType: "String"
            }
        ],
        ag_grid: {
            selectedTheme: "ag-theme-balham"
        },
        typesIdent: [],
        onlyInconsistencies: false
    };
};

export default {
    magneticMediaFormats: defaultMagneticMediaFormats(),
    magneticMediaConcepts: defaultMagneticMediaConcepts(),
    magneticMediaColumns: defaultMagneticMediaColumns(),
    magneticMediaRangeAccounts: defaultMagneticMediaRangeAccounts(),
    magneticMediaReport: defaultMagneticMediaReport(),
    onChangeDep: 0,
    magneticMediaCurrentEditContact: null
};



// WEBPACK FOOTER //
// ./src/modules/magneticMedia/state.js